import { ExecutionStatus } from './ExecutionStatus';
import { Issue } from './Issue';
import { JiraAttachment } from './JiraAttachment';
import TestStep from './TestStep';

export default class TestExecutionStep {
  id: number;
  testExecutionStepId: number;
  step: string;
  result: string;
  data: string;
  attachments: Array<JiraAttachment>;
  status: ExecutionStatus;
  comment: string;
  isSelected: boolean;
  executionAttachments: Array<JiraAttachment>;
  linkedIssues: Array<Issue>;
  isStatusUpdate: boolean;

  constructor(testStep: TestStep) {
    if (testStep) {
      this.id = testStep.id;
      this.step = testStep.step;
      this.result = testStep.result;
      this.data = testStep.data;
      this.attachments = testStep.attachments;
      this.executionAttachments = testStep.executionAttachments;
    }
    this.comment = '';
  }

  toRestEntity(): {
    id: number;
    testCaseStepId: number;
    statusObject: ExecutionStatus; // TODO: replace with status after we discard statusObject
    comment: string;
    attachments: string;
    linkedIssues: Array<Issue>;
  } {
    const attachments = this.executionAttachments
      ? JSON.stringify(
          this.executionAttachments.map((attachment) => ({ id: attachment.id }))
        )
      : '[]';
    return {
      id: this.testExecutionStepId,
      testCaseStepId: this.id,
      statusObject: this.status, // TODO: replace with status after we discard statusObject
      comment: this.comment,
      attachments,
      linkedIssues: this.linkedIssues,
    };
  }
}
